// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"34fd5e3f","732":"d6e3444f","977":"749b20fe"}[chunkId] + ".chunk.js";
};